import React, {useEffect, useState} from 'react';
import Tab from "../../../../shared/ui/tab/Tab";
import {ToggleCartButton} from "../../../goods/toggle-goods-to-cart";
import {useProductSearchStore} from "../../model/store";

import {Navigation, Scrollbar} from 'swiper/modules'
import 'swiper/css';
import {Swiper, SwiperSlide} from "swiper/react";
import styled from "styled-components";
import RecommendCard from "../../../../entities/goods/ui/card/RecommendCard";
import PreviewGoods from "../../../../entities/goods/ui/preview/PreviewGoods";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";
import {GoodsType} from "../../../../entities/goods/model/types/goods-type";

const StyledRecommendationTabAnimation = styled.div`
    max-height: 0;
    overflow: hidden;
    transform: translateY(-100%);
    transition: all 0.250s ease;

    &.${GLOBAL_STYLE_CONFIG.splitByPrefix('is-visible')} {
        max-height: 5000px; /* Задать максимум больше, чем может быть контент */
        transform: translateY(0%);
        overflow: visible;
    }

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('tab-content')} {
        margin: 0 -10px;
    }
`

/**
 * Компонента, которая отвечает за получение и отображение рекомендуемых товаров
 *
 * @returns {JSX.Element} - секция с табами и товарами
 */
interface RecommendationTabProps{
    ToggleToCartButtonSlot: React.FC<{ goods: GoodsType }>;
}
const RecommendationTab:React.FC<RecommendationTabProps> = ({ToggleToCartButtonSlot}) => {
    const products = useProductSearchStore(state => state.products);
    const [isLoad, setLoad] = useState(false);
    const [tabActive, setTabActive] = useState(1);
    useEffect(() => {
        setTimeout(() => {
            setLoad(true);
        }, 10)
    }, [])
    return (
        <StyledRecommendationTabAnimation
            className={`${isLoad ? GLOBAL_STYLE_CONFIG.splitByPrefix("is-visible") : ""}`}>
            <Tab>
                <Tab.Navigation>
                    <Tab.NavItem isActive={tabActive === 1} onToggle={() => {
                        setTabActive(1)
                    }}>
                        С этим покупают
                    </Tab.NavItem>
                    <Tab.NavItem isActive={tabActive === 2} onToggle={() => {
                        setTabActive(2)
                    }}>
                        Похожие
                    </Tab.NavItem>
                </Tab.Navigation>
                <Tab.Content>
                    <Swiper modules={[Scrollbar, Navigation]}
                            spaceBetween={10}
                            slidesPerView="auto"
                            scrollbar={{draggable: true}}
                            grabCursor={true}
                            pagination={{clickable: true}}
                            navigation
                            style={{padding: '0 40px'}}
                    >
                        {products?.slice(0, 12).map((goods) => (
                            <SwiperSlide style={{maxWidth: '140px'}}>
                                <RecommendCard goods={goods}
                                               slotPreview={
                                                   <PreviewGoods/>
                                               }
                                               slotBasket={
                                                   <ToggleToCartButtonSlot
                                                       goods={goods}
                                                       key={`recommend-basket-${goods.id}`}/>
                                               }
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Tab.Content>

            </Tab>
        </StyledRecommendationTabAnimation>
    )
        ;
};

export default RecommendationTab;